export function pattern_boil({compId,shapeHeight,animationSpeed,flipAnimation}) {
  let stdDeviation = 24,
      gFilter = `filter="url(#blend_deep_${compId})"`,
      rectFilter = '';
  if('MozAppearance' in document.documentElement.style) {
    stdDeviation = 12;
    rectFilter = gFilter;
    gFilter = '';
  }
  return `
  <filter id="blend_deep_${compId}">
    <feGaussianBlur in="SourceGraphic" stdDeviation="${stdDeviation}" result="blur" />
    <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 72 -23" result="blend_${compId}" />
    <feBlend in="SourceGraphic" in2="blend_${compId}" />
  </filter>
  <pattern class="patternRepeat" id="pat_${compId}" patternUnits="userSpaceOnUse" style="transform: translate(${-shapeHeight*4}px,0)" height="${shapeHeight}" viewbox="0 0 1920 240" x="50%" y="0" preserveAspectRatio="none" width="${shapeHeight*8}">
    <g ${gFilter}>
    <g>
    <path d="M248.9,285.3L90.5,364.5c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0l158.4,79.2
      C298.9,219.7,298.9,260.3,248.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 30;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M488.9,285.3l-158.4,79.2c-50,25-131,25-181,0L-8.9,285.3c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0l158.4,79.2
      C538.9,219.7,538.9,260.3,488.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 50;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.75 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M728.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0l158.4,79.2
      C778.9,219.7,778.9,260.3,728.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 30;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.5 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M968.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0l158.4,79.2
      C1018.9,219.7,1018.9,260.3,968.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 50;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.25 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M1208.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1258.9,219.7,1258.9,260.3,1208.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 30;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M1448.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1498.9,219.7,1498.9,260.3,1448.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 50;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.25 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M1688.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1738.9,219.7,1738.9,260.3,1688.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 30;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.5 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M1928.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1978.9,219.7,1978.9,260.3,1928.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 50;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.75 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M2168.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C2218.9,219.7,2218.9,260.3,2168.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 30;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M1448.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1498.9,219.7,1498.9,260.3,1448.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="960 0;960 50;960 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.75 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M1688.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1738.9,219.7,1738.9,260.3,1688.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="960 0;960 30;960 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.5 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M1928.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1978.9,219.7,1978.9,260.3,1928.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="960 0;960 50;960 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.25 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M2168.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C2218.9,219.7,2218.9,260.3,2168.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="960 0;960 30;960 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${0 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M1448.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1498.9,219.7,1498.9,260.3,1448.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1920 0;1920 50;1920 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.25 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M1688.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1738.9,219.7,1738.9,260.3,1688.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1920 0;1920 30;1920 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.5 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M1928.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C1978.9,219.7,1978.9,260.3,1928.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1920 0;1920 50;1920 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3*0.75 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M2168.9,285.3l-158.4,79.2c-50,25-131,25-181,0l-158.4-79.2c-50-25-50-65.5,0-90.5l158.4-79.2c50-25,131-25,181,0
      l158.4,79.2C2218.9,219.7,2218.9,260.3,2168.9,285.3z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1920 0;1920 30;1920 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </path>


    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;-1920 0"
    keyTimes="0;1"
    keySplines="0 0 1 1" calcMode="spline"
    
    dur="${36 * animationSpeed}s" repeatCount="indefinite"/>
    </g>

    <circle stroke="none" stroke-miterlimit="10" cx="960" cy="240" r="20">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${0 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="430" cy="240" r="18">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1 * animationSpeed}s"
      dur="${3.5 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="190" cy="240" r="20">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2 * animationSpeed}s"
      dur="${3.25 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="1200" cy="240" r="22">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1 * animationSpeed}s"
      dur="${2.75 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="1770" cy="240" r="20">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3 * animationSpeed}s"
      dur="${3.75 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="760" cy="240" r="16">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2 * animationSpeed}s"
      dur="${4 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>

    <circle stroke="none" stroke-miterlimit="10" cx="1120" cy="240" r="20">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0.4 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="550" cy="240" r="18">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1.8 * animationSpeed}s"
      dur="${3.5 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="1600" cy="240" r="20">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0.5 * animationSpeed}s"
      dur="${3.25 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="1390" cy="240" r="22">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1.5 * animationSpeed}s"
      dur="${2.75 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="1320" cy="240" r="20">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2.2 * animationSpeed}s"
      dur="${3.75 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    <circle stroke="none" stroke-miterlimit="10" cx="810" cy="240" r="16">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2.5 * animationSpeed}s"
      dur="${4 * animationSpeed}s" repeatCount="indefinite"/>
    </circle>
    </g>
  </pattern>
  <mask id="mask_${compId}">
    <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})" ${rectFilter}></rect>
  </mask>
  <mask class="flipped" id="mask_single_${compId}">
    <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
  </mask>
`;
}